import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from '@mui/material/OutlinedInput';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import { changePassword } from "../../Services/auth";
import { ToastError, ToastSuccess } from "../../CustomToaster/CustomToaster";
import { InputError } from "../Errors/ErrorText";

function ChangePassword() {
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const [showPassword1, setShowPassword1] = React.useState(false);

    const handleClickShowPassword1 = () => setShowPassword1((show) => !show);

    const handleMouseDownPassword1 = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword1 = (event) => {
        event.preventDefault();
    };


    const [showPassword2, setShowPassword2] = React.useState(false);

    const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

    const handleMouseDownPassword2 = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword2 = (event) => {
        event.preventDefault();
    };

    //custom code
    const [userData, setUserData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    const [errors, setErrors] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });
    const [load, setLoad] = useState(false)

    const handleChange = async (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setUserData({
            ...userData,
            [name]: value
        });

        setErrors({
            ...errors,
            [name]: ""
        })
    }


    const validate = () => {
        let formErrors = {};
        let isValid = true;
        if (!userData.currentPassword) {
            formErrors.currentPassword = "current password is required";
            isValid = false;
        }
        if (!userData.confirmPassword) {
            formErrors.confirmPassword = "Confirm password is required";
            isValid = false;
        }
        if (!userData.newPassword) {
            formErrors.newPassword = "new password is required";
            isValid = false;
        } else if (userData.newPassword.length < 8) {
            formErrors.newPassword = "new password must be at least 8 characters long";
            isValid = false;
        } else if (
            !/[A-Z]/.test(userData.newPassword) ||
            !/[a-z]/.test(userData.newPassword)
        ) {
            formErrors.newPassword =
                "new password must be one uppercase and one lowercase letter";
            isValid = false;
        } else if (
            !/\d/.test(userData?.newPassword) ||
            !/[!@#$%^&*(),.?":{}|<>]/.test(userData?.newPassword)
        ) {
            formErrors.newPassword =
                " new password must be with one number and one special character";
            isValid = false;
        } else if (userData.newPassword.length < 8) {
            formErrors.newPassword =
                "new password must be at least 8 characters long";
            isValid = false;
        }
        else if (userData.newPassword.length > 30) {
            formErrors.newPassword = "new password must be within 30 characters";
            isValid = false;
        }
        else if (!userData.confirmPassword) {
            formErrors.confirmPassword = "confirm password is required";
            isValid = false;
        }
        else if (userData.newPassword != userData.confirmPassword) {
            formErrors.confirmPassword = "confirm password does not match";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setLoad(true);
            const data = {
                newPassword: userData.newPassword,
                confirmPassword: userData.confirmPassword,
                currentPassword: userData?.currentPassword
            };

            const response = await changePassword(data);

            if (response?.data?.success === true) {
                ToastSuccess({ message: response?.data?.message })

                setLoad(false);

                setUserData({
                    newPassword: "",
                    confirmPassword: "",
                    currentPassword: ""
                });
            } else {
                ToastError({ message: response?.data?.message })


                setLoad(false);
            }
        }
    };


    return (
        <div className="Kyc">
            <Box component="main" sx={{ marginTop: "50px", margin: "0 auto", }}>
                <div className="display-2 mb-30" >
                    <h2 className="gold-color">Change Password</h2>
                </div>
                <Grid container sx={{ justifyContent: 'center' }}>
                    <Grid item size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }} className="card-box">
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="text-center"><h2 className="profile-heading gold-color">New password
                            </h2></Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
                                <div className="input-common mt-20" >
                                    <label>Current Password</label>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        placeholder="Current password"
                                        type={showPassword ? 'text' : 'password'}
                                        value={userData.currentPassword}
                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        name="currentPassword"
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }

                                    />
                                    <InputError error={errors.currentPassword} />
                                </div>
                            </Grid>

                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <div className='input-common mt-20 '>
                                    <FormLabel>New password</FormLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        placeholder="New password"
                                        type={showPassword1 ? 'text' : 'password'}
                                        value={userData.newPassword}
                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        // onKeyDown={validateFocus}
                                        error={!!errors.newPassword}
                                        helperText={errors?.newPassword}
                                        name="newPassword"
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword1 ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword1}
                                                    onMouseDown={handleMouseDownPassword1}
                                                    onMouseUp={handleMouseUpPassword1}
                                                    edge="end"
                                                >
                                                    {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }

                                    />
                                    <InputError error={errors.newPassword} />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <div className='input-common mt-20'>
                                    <FormLabel>Confirm Password</FormLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        placeholder="Confirm password"
                                        type={showPassword2 ? 'text' : 'password'}
                                        value={userData.confirmPassword}
                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        // onInput={validateFocus}
                                        error={!!errors.confirmPassword}
                                        helperText={errors?.confirmPassword}
                                        name="confirmPassword"
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword2 ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword2}
                                                    onMouseDown={handleMouseDownPassword2}
                                                    onMouseUp={handleMouseUpPassword2}
                                                    edge="end"
                                                >
                                                    {showPassword2 ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }

                                    />
                                    <InputError error={errors.confirmPassword} />

                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <p className="notes-password">Notes : Your password must contain at least 8 characters, one uppercase (ex: A, B, C, etc), one lowercase letter, one numeric digit (ex:1, 2, 3, etc) and one special character (ex: @, #, $, etc)
                                </p>
                            </Grid>

                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <div className="blu-btn display-3 mt-20">
                                    {
                                        load === true ?
                                            <Button sx={{ width: "100%" }}
                                                disabled
                                            >Progressing</Button>
                                            :
                                            <Button sx={{ width: "100%" }}
                                                onClick={(e) => {
                                                    handlePasswordSubmit(e);
                                                }}
                                            >Change Password</Button>
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>


            </Box>

        </div>
    );
}

export default ChangePassword;
